import { graphql } from "gatsby"
import React from "react"

import Combo from "@molecules/Combo/Combo"

const Combo5050 = ({ blockDataCombo }) => {
  const { variant, heading, text, image, quoted, links } = blockDataCombo || {}

  return (
    <section className="global-combo">
      <Combo
        variant={variant}
        title={heading}
        text={text}
        image={image}
        aspectRatio="7:5"
        quoted={quoted}
        links={links}
      />
    </section>
  )
}

export const query = graphql`
  fragment Combo5050 on WpBlockAcfCombo5050 {
    __typename
    blockDataCombo {
      variant
      heading
      text
      quoted
      image {
        mediaDetails {
          width
          height
        }
        cloudinaryDetails {
          public_id
          original_filename
          format
        }
        sourceUrl
        altText
        altTextOriginal
      }
      links {
        link {
          url
          title
          target
        }
      }
    }
  }
`

export default Combo5050
